var exports = {
  "k": "x112a1f60--390e54--container",
};

module.exports = exports;
